module.exports = __webpack_public_path__ + "img/honour.cab80f27.png";